import React, { useState } from 'react';
import SidebarMenu from "../components/SidebarMenu";
import { TabMenu } from 'primereact/tabmenu';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../styles/layout.css';

// Admin altı componentler
import Employees from '../components/admin/Employees';
import ApprovalSteps from '../components/admin/ApprovalSteps';
import ExpenseApprovalSteps from "../components/admin/ExpenseApprovalSteps";
import DepartmentsPositions from "../components/admin/DepartmentsPositions";

function AdminPage() {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    { label: 'Çalışanlar', icon: 'pi pi-users' },
    { label: 'İzin Onay Adımları', icon: 'pi pi-sitemap' },
    { label: 'Harcama Onay Adımları', icon: 'pi pi-sitemap' },
    { label: 'Departman-Pozisyon İşlemleri', icon: 'pi pi-sitemap' }
  ];

  const renderComponent = () => {
    switch (activeIndex) {
      case 0: return <Employees />;
      case 1: return <ApprovalSteps />;
      case 2: return <ExpenseApprovalSteps />;
      case 3: return <DepartmentsPositions />;
      default: return null;
    }
  };

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        />
        <div className="tab-content" style={{ marginTop: '1rem' }}>
          {renderComponent()}
        </div>
      </main>
    </div>
  );
}

export default AdminPage;
